import React, { useEffect, useRef, useState } from 'react';
import SniffButton from '../../components/sniff-button';
import Reviews from '../../components/reviews';
import './reviews.scss';

const CTAButton = ({ city, stateShort, className = 'mt-4', exploreLink }) => (
    <a href={exploreLink} rel="nofollow">
        <SniffButton size="lg" block="mobile" className={className}>
            Explore spots in {city.name}, {stateShort.toUpperCase()}
        </SniffButton>
    </a>
);

const SeoReviews = ({ city, cityReviews, exploreLink, subObj, listings }) => {
    const title = listings
        ? `What people are saying about Sniffspot ${subObj?.seoTitle.toLowerCase() || 'dog parks'}`
        : `What people say about ${subObj?.seoTitle.toLowerCase() || 'dog parks'} around ${city.name}, ${city.state}`;

    if (cityReviews?.length == 0) {
        return '';
    }

    return (
        <div className="sniff-reviews">
            <div className="l-container">
                <h2 className="snif-m2 snif-l2-pc snif-semibold mb-2 mb-md-4">{title}</h2>
                <Reviews items={cityReviews} seoTest {...{ useEffect, useRef, useState }} />
                {!listings && (
                    <div className="text-center">
                        <CTAButton city={city} stateShort={city.stateShort} exploreLink={exploreLink} className="mt-1" />
                    </div>
                )}
            </div>
        </div>
    );
};

export default SeoReviews;
